interface GearWithCheckmarkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearWithCheckmarkSVG = ({ color, style }: GearWithCheckmarkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="50"
    viewBox="0 0 48 50"
    fill="none"
  >
    <g clipPath="url(#clip0_875_26207)">
      <path
        d="M46.1341 17.3459L47.0867 16.3491L42.9994 9.25999L41.6592 9.59229C38.9121 10.268 36.0322 9.80275 33.5954 8.38494C33.5732 8.37386 33.54 8.35171 33.5067 8.34063C31.0477 6.92282 29.1868 4.66319 28.4004 1.93833L28.0127 0.609131H19.8382L19.4505 1.93833C18.664 4.66319 16.8142 6.92282 14.3552 8.32956C14.3441 8.32956 14.3331 8.34063 14.322 8.35171C14.3109 8.35171 14.2998 8.36279 14.2888 8.37386C11.8408 9.79167 8.9498 10.279 6.2028 9.59229L4.86252 9.25999L0.76416 16.3491L1.71675 17.3459C3.6884 19.3951 4.70745 22.1311 4.70745 24.9667C4.70745 24.9999 4.70745 25.0331 4.70745 25.0664C4.70745 27.8909 3.67732 30.6158 1.71675 32.6539L0.76416 33.6508L4.85144 40.7398L6.19172 40.4075C8.93873 39.7319 11.8187 40.1971 14.2555 41.6149C14.2888 41.626 14.3109 41.6481 14.3441 41.6592C16.8032 43.077 18.664 45.3366 19.4505 48.0615L19.8382 49.3907H28.0127L28.4004 48.0615C29.1868 45.3366 31.0366 43.077 33.4957 41.6703C33.5067 41.6703 33.5178 41.6592 33.5289 41.6481C33.54 41.6481 33.551 41.637 33.5621 41.626C36.0101 40.2082 38.9011 39.7208 41.6481 40.4075L42.9884 40.7398L47.0756 33.6508L46.123 32.6539C44.1514 30.6047 43.1323 27.8688 43.1323 25.0331C43.1323 24.9999 43.1323 24.9667 43.1323 24.9335C43.1323 22.1089 44.1625 19.3841 46.123 17.3459H46.1341Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M28.1796 35.2633C33.6802 32.9693 36.2923 26.6201 34.0139 21.0818C31.7354 15.5436 25.4292 12.9137 19.9286 15.2077C14.4279 17.5017 11.8158 23.8509 14.0942 29.3892C16.3727 34.9274 22.6789 37.5573 28.1796 35.2633Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.0454 25.4503L23.7604 27.6916L27.6914 23.261"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_875_26207">
        <rect width="47.8511" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GearWithCheckmarkSVG;
